namespace SPA
{
	export namespace Guide
	{
		export abstract class GuideContent extends ui.base.BaseHTMLElement
		{

			protected	m_Panel:				GuidePanel|null;
			private		m_Navigation:		ui.base.BaseHTMLElement;
			private		m_ContentPlane:	ui.base.BaseHTMLElement;
			private		m_ContentBuilt: boolean;

			public constructor()
			{
				super( 'guide-item-content' );

				this.m_Panel				= null;
				this.m_Navigation		= new ui.base.BaseHTMLElement( 'guide-navigation' );
				this.m_ContentPlane	= new ui.base.BaseHTMLElement( 'div' ).addClass( 'clearfix' );
				this.m_ContentBuilt	= false;

				this.m_ContentPlane.appendTo( this );

				this.m_Navigation
					.css(
						{
							'padding-left':		'15px',
							'padding-right':	'15px'
						}
					)
				.appendTo( this );

			}

			public setPanel( panel: GuidePanel )
			{
				this.m_Panel = panel;
			}

			public rebuild( root: ui.base.BaseHTMLElement, ...args: any[] ): GuideContent
			{
				this.appendTo( root );

				this.m_Navigation.empty();
				this.m_ContentPlane.empty();

				this.build( this.m_ContentPlane );
				this.buildNavigation( this.m_Navigation );

				return this;
			}

			public abstract build( root: ui.base.BaseHTMLElement, ...args: any[] ): void;
			protected abstract buildNavigation( nav: ui.base.BaseHTMLElement ): void;

			protected addToForm(
				_root: ui.base.BaseHTMLElement,
				_form: ui.Form.Form,
				_input: ui.Form.BasicInputField
			): void
			{
				_input.rebuild( _root );
				_form.Input( _input );
			}

		}
	}
}
